import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-us-sent',
  templateUrl: './contact-us-sent.component.html',
  styleUrls: ['./contact-us-sent.component.css']
})
export class ContactUsSentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
